import React from 'react'
import Search from '../components/Search.js'
import Navbar from '../components/Navbar.jsx'
import Footer from '../components/Footer.jsx'

function People() {
  return (
    <div>
      <Navbar/>       
      <Search/>
      <Footer/>
    </div>
  )
}

export default People
